import { Box, SxProps, Tabs, TabsProps, Theme, useTheme } from '@mui/material'
export interface MolsonTabsProps extends TabsProps {
  dataTestId?: string
  sx?: SxProps<Theme>
}

export const MolsonTabs = ({
  dataTestId,
  children,
  sx,
  ...props
}: MolsonTabsProps) => {
  const theme = useTheme()

  const defaultSx: SxProps<Theme> = {
    marginBottom: 4,
    borderBottom: `1px solid ${theme.palette.secondary[300]}`
  }

  return (
    <Box sx={{ ...defaultSx, ...sx }}>
      <Tabs data-testid={dataTestId} {...props}>
        {children}
      </Tabs>
    </Box>
  )
}
